export const SEARCH_USER = "SEARCH_USER";
export const SEARCH_USER_INIT = "SEARCH_USER_INIT";
export const SEARCH_USER_END = "SEARCH_USER_END";
